(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jeep-recovery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.jr-card').forEach(function(card) {
    card.addEventListener('click', function() {
      var section = card.closest('.jr-section');
      var src = section ? section.getAttribute('data-pdp-jeep') : '';
      var target = card.getAttribute('data-jr-target') || '';
      try {
        if (window.gtag) {
          window.gtag('event', 'jeep_recovery_click', { jeep_source: src, recovery_target: target });
        }
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'jeep_recovery_click', jeep_source: src, recovery_target: target });
        }
      } catch (e) {}
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tech-specs"] && !Shopify.designMode) return;
  try {
    // EF-Tech-Specs: Sidebar-Duplikate ausblenden wenn tech-specs auf Seite
  document.addEventListener('DOMContentLoaded', function() {
    if (!document.querySelector('.ts-section')) return;
    var hideMarkers = [
      'Warum dieses E-Bike im Alltag',
      'Produktbeschreibung-Akkordion'
    ];
    // Sidebar Blocks (im product-column-right) durchsuchen
    var sidebar = document.querySelector('.product-column-right');
    if (!sidebar) return;
    var blocks = sidebar.querySelectorAll(':scope > * > *, :scope > *');
    blocks.forEach(function(el) {
      var txt = el.innerText || '';
      // Trust-Block "Warum dieses E-Bike im Alltag überzeugt"
      if (txt.indexOf('Warum dieses E-Bike im Alltag') > -1 && txt.length < 500) {
        el.style.display = 'none';
      }
    });
    // Description-Akkordion in Sidebar (Inhalts-Match)
    sidebar.querySelectorAll('details, .accordion, .product-info-accordion').forEach(function(acc) {
      var summaryText = (acc.querySelector('summary, .accordion-title, button') || {}).innerText || '';
      if (summaryText.match(/^Beschreibung$|^Lieferumfang$/i)) {
        acc.style.display = 'none';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
